// Site-wide configuration settings
export const siteConfig = {
    // Lockdown mode - controlled by environment variable
    lockdownMode: process.env.REACT_APP_LOCKDOWN_MODE === 'true',

    // Contact information
    contact: {
        email: "contact@lukasschulte.com",
        // Add other contact methods if needed
    }
}; 